// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pear"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18.5869 12.4871C21.0618 10.0123 20.7082 7.53738 18.5869 5.41606C16.4656 3.29474 13.9907 2.94118 11.5158 5.41606C7.27319 9.6587 6.56608 6.12316 3.3841 9.30514C1.17613 11.5131 1.26278 16.3762 6.21253 17.7904C7.62674 22.7402 12.4898 22.8268 14.6978 20.6189C17.8798 17.4369 14.3443 16.7298 18.5869 12.4871Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.9817 2.98145C19.2483 4.44828 18.3369 5.66342 16.8701 7.13026M18.5869 5.41611C20.7082 7.53744 21.0618 10.0123 18.5869 12.4872C14.3443 16.7298 17.8798 17.4369 14.6978 20.6189C12.4898 22.8269 7.62674 22.7402 6.21253 17.7905C1.26278 16.3763 1.17613 11.5132 3.3841 9.3052C6.56608 6.12322 7.27319 9.65876 11.5158 5.41611C13.9907 2.94124 16.4656 3.29479 18.5869 5.41611Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PearIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pear',
    ref,
    icon: element,
  },
));

PearIcon.displayName = 'PearIcon';

export default PearIcon;
